<div class="mt-4">
  <h5>Worker Verification</h5>
  <worker-verification-warning
    [currentDocument]="currentDocument"
  ></worker-verification-warning>

  <!-- US 6921: widen the action column when it also shows the allowed-roles chips -->
  <div class="mat-container" [class.has-sign-roles]="!!signRoleCodes">
    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="user">
        <mat-header-cell *matHeaderCellDef>User</mat-header-cell>
        <mat-cell *matCellDef="let e" class="bold">{{ e.user.name }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
        <mat-cell *matCellDef="let e" class="date">{{
          e.date | date: "medium"
        }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>
          <!-- US 6921: roles whose privilege allows signing this Worker Verification, next to the "+" -->
          <span class="sign-roles" *ngIf="signRoleCodes">
            <role-chips [roleCodes]="signRoleCodes" [noWrap]="true"></role-chips>
          </span>
          <!-- Original behavior (forms that do not opt in): the "+" shows only to privilege holders. -->
          <button
            mat-icon-button
            color="accent"
            (click)="addSignature()"
            *ngIf="!enhancedSign && !disableButtons && !signed && hasPrivilege(privilegeToSign)"
            matTooltip="Add Worker Verification Signature"
          >
            <mat-icon>add_box</mat-icon>
          </button>
          <!-- Enhanced (opt-in, e.g. RSF): the "+" is visible to everyone during a signable status
               but disabled for users without the privilege, with an explanatory tooltip. Wrapped in
               a span so the tooltip still shows while the button is disabled. -->
          <span
            *ngIf="enhancedSign && !disableButtons && !signed"
            [matTooltip]="addTooltip"
          >
            <button
              mat-icon-button
              color="accent"
              (click)="addSignature()"
              [disabled]="!hasPrivilege(privilegeToSign)"
            >
              <mat-icon>add_box</mat-icon>
            </button>
          </span>
          <!-- Non-prod tester tool: add a signature as a user who holds the required privilege. -->
          <button
            mat-icon-button
            color="warn"
            type="button"
            (click)="testApprove()"
            *ngIf="showTestApprove()"
            matTooltip="Tester tool (non-production): adds a Worker Verification signature as a user with the required privilege."
            [matTooltipPosition]="'right'"
          >
            <mat-icon>auto_fix_high</mat-icon>
          </button></mat-header-cell
        >
        <mat-cell *matCellDef="let e">
          <button
            mat-icon-button
            color="warn"
            (click)="remove()"
            matTooltip="Remove Signature"
            *ngIf="e.userID == getCurrentUser()?.id && !disableButtons"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="displayed_columns; sticky: true"
      ></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayed_columns"></mat-row>
    </mat-table>
  </div>
</div>
